import { parseToHsl } from "polished";
import { isEmpty, isNil } from "ramda";
import colors from "../styles/colors";

const getTextColor = (backgroundColor: string) => {
  if (isNil(backgroundColor) || isEmpty(backgroundColor)) return colors.textDarkBlue;

  const hslColor = parseToHsl(backgroundColor);
  return hslColor.lightness > 0.5 ? colors.textDarkBlue : colors.white;
};

export const getThemeColorsFromLessString = (lessCode: string) => ({
  headerAccent: getThemeColorFromLessVariable(lessCode, "@skin-accent-background-color"),
  headerBackground: getThemeColorFromLessVariable(lessCode, "@skin-site-header-background-color"),
  headerButton: getThemeColorFromLessVariable(lessCode, "@skin-site-header-color"),
  headerTextColor: getTextColor(getThemeColorFromLessVariable(lessCode, "@skin-site-header-background-color")),
  navigationButtons: getThemeColorFromLessVariable(lessCode, "@skin-color-primary-action"),
  progressBar: getThemeColorFromLessVariable(lessCode, "@skin-color-completed"),
  tableHeadersTextColor: getTextColor(getThemeColorFromLessVariable(lessCode, "@skin-accent-background-color")),
});

export const getThemeDefaultColor = () => ({
  headerAccent: colors.headerAccent,
  headerBackground: colors.headerBackground,
  headerButton: colors.headerButton,
  headerTextColor: colors.headerTextColor,
  navigationButtons: colors.navigationButtons,
  progressBar: colors.progressBar,
  tableHeadersTextColor: colors.tableHeadersTextColor,
});

export const getThemeColorFromLessVariable = (lessCode: string, lessVar: string): string => {
  const value = lessCode.split("\n").find((line: string) => line.split(":")[0] === lessVar);
  if (!value) return "#FFFFFF";
  const [, color] = value.split(":");

  return color?.trim().slice(0, -1) ?? "#fff";
};
